<template>
  <div class="app flex-row align-items-center">
    <loading :active.sync="isLoading"></loading>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="login($event)">
                  <h1>{{ $t("login.header") }}</h1>
                  <p class="text-muted">{{ $t("login.sign_in") }}</p>
                  <b-input-group class="mb-3 form-group">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" :class="{ 'is-invalid': !$v.user.email.required && $v.user.email.$dirty }" v-model.trim="$v.user.email.$model" class="form-control" placeholder="Email" autocomplete="Email" />
                  </b-input-group>
                  <p class="error" v-if="!$v.user.email.required && $v.user.email.$dirty">{{ $t("login.email_required") }}.</p>
                  <b-input-group class="mb-4 form-group">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" :class="{ 'is-invalid': !$v.user.password.required && $v.user.password.$dirty }" v-model.trim="$v.user.password.$model" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>
                  <p class="error" v-if="!$v.user.password.required && $v.user.password.$dirty">{{ $t("login.password_required") }}.</p>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" type="submit">{{ $t("login.button_login") }}</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">{{ $t("login.forgot_password") }}</b-button>
                    </b-col>
                    <b-col cols="12">
                      <b-button @click="goToRegister()" variant="primary" class="register-btn mt-3">{{ $t("login.register") }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <p class="information-header">{{ $t("login.register_information_header") }} </p>
                  <p class="information-subheader">{{ $t("login.register_information_subheader") }} </p>
                  <p class="label">{{ $t("login.register_information_line1") }} </p>
                  <p class="label">{{ $t("login.register_information_line2") }}</p>
                  <p class="label">{{ $t("login.register_information_line3") }}</p>
                  <p class="label">{{ $t("login.register_information_line4") }}</p>
                  <p class="label">{{ $t("login.register_information_line5") }}</p>
                  <p class="label">{{ $t("login.register_information_line6") }}</p>
                  <b-button @click="goToRegister()" variant="primary" class="active mt-3">{{ $t("login.register") }}</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import '@/assets/scss/login.scss';
  import { required } from 'vuelidate/lib/validators'
  import LoginService from '@/services/login.service.js';
  import DataMenuService from '@/services/datamenu.service.js';
  import MenuService from '@/services/menu.service.js';
  import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
  import Models from '@/store/ORM/models.js';


export default {
  name: 'Login',
  data() {
    return {
      user: {
        email: '',
        password: '',
        type: 'nutritionist'
      },
      isLoading: false
    }
  },
  validations: {
    user: {
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  
  methods:{
    login : function(evt){
      var vm = this;
      evt.preventDefault();
      this.isLoading = true;
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      this.$store.dispatch('UserModules/UpdateUser', null)
      this.$store.dispatch('UserModules/UpdateToken', null)
      LoginService.login(this.user).then((result)=>{
        if(result.data.success){
          localStorage.setItem('token',result.data.data.accessToken);

          // console.log(
          //   Message.Create({ data: result.data.user.nutritionist.messages })
          // )



        let cart = Models.Cart.query().first();

        if(!cart) {
            Models.Cart.insert({
                data: {id:1}
            });
        }

          try {
            let references = result.data.user.nutritionist.references;
            Models.Reference.create({
              data: references
            })
          } catch (err) {
            console.log(err.message)
          }

          try {
            Models.PrivateNote.create({ data: result.data.user.nutritionist.private_notes })
          } catch (err) {
            console.log(err.message)
          }

          // try {
          //   Models.InternalMessage.create({ data: result.data.user.nutritionist.messages })
          // } catch (err) {
          //   console.log(err.message)
          // }

          // INIT THE CLIENT SET BELONGING TO THE NUTRITIONIST

          try {
            MenuService.getMenus(result.data.user.nutritionist.id).then((res)=>{
              
              if(!!res && res.results){
                clients.map((elm)=>{
                  let menus = res.data.filter((el)=> el.client == client.id);
                  elm.menus = menus;
                });
              }

              let clients = result.data.user.nutritionist.clients;
              clients.private_notes = result.data.user.nutritionist.private_notes;
              clients.events = result.data.user.nutritionist.events;
              console.log("clients",clients);
              // clients.weight_height_sets = [];
              Models.Client.create({
                data: clients,
                insert: ['tests','weight_height_sets']
              });
            }, err =>{
              let clients = result.data.user.nutritionist.clients;
              clients.private_notes = result.data.user.nutritionist.private_notes;
              clients.events = result.data.user.nutritionist.events;
              console.log("clients",clients);
              // clients.weight_height_sets = [];
              Models.Client.create({
                data: clients,
                insert: ['tests','weight_height_sets']
              })
              // clients.forEach(client => {
              //   console.log(client.weight_height_sets[0]);
              //   Models.WeightHeightSet.create({
              //     data: client.weight_height_sets[0]
              //   })
              // });
            })
          } catch (err) {
            console.log(err.message)
          }


          try {
            DataMenuService.setAxios();
            DataMenuService.getMenus(result.data.user.nutritionist.id).then((menusRes)=>{
              Models.CreatedMenu.create({ data: menusRes.data });
            })
          } catch (err) {
            console.log(err.message)
          }
          
          // INIT THE NUTRITIONIST
          
          try {
            Models.Nutritionist.create({
              data: result.data.user.nutritionist,
              insert: ['clients', 'messages']
            })
          } catch (err) {
            console.log(err.message)
          }
          
          try {
            this.$store.dispatch('UserModules/UpdateUser', result.data);
            this.$store.dispatch('UserModules/UpdateToken', result.data.data.accessToken);
            this.$store.dispatch('UserModules/FetchToken');

            localStorage.setItem('loggedin', true);
            // this.$store.dispatch('UserModules/StopLogin');
            this.$toastr.success('You are now Logged in!', 'You are now Logged in!');

            vm.isLoading = false;
            vm.$router.push({ path: '/dashboard' });

          } catch (err) {
              vm.isLoading = false;
            console.log(err.message)
          }

        }else{
          vm.$toastr.error(result.data.message,result.data.message);
          vm.isLoading = false;
        }
         
        // vm.$store.dispatch('UserModules/StopLogin');
        // vm.$toastr('success', 'Success', 'You are now Logged in!');
      }).catch((err)=>{
        if(err.response.status == 400){
          if(!!err.response.data.non_field_errors){
            err.response.data.non_field_errors.forEach((element) => {
              this.$toastr.error(element,element);
            });
          }
        }else{
          this.$toastr.error(err.response.statusText, err.response.statusText);
        }
        
        localStorage.removeItem('loggedin');
        localStorage.removeItem('vuex');
        this.isLoading = false;
      });
    },

    setRole : function(role){
      this.user.role = role;
    },
    goToRegister(){
      this.$router.push('/register');
    }
  }
}
</script>

<style>

.register-btn{
  display: none;
}
@media (max-width: 991.98px){
  .register-btn{
    display: flex !important;
  }
}
</style>